<template>
  <div class="hs-slider">
    <div
      class="hs-slider__top"
      @mouseenter="sliderArrowsNavVisible = true"
      @mouseleave="sliderArrowsNavVisible = false"
    >
      <button
        v-show="sliderArrowsNavVisible"
        @click.prevent="prevSlide()"
        class="sc-nav-left"
      >&lsaquo;</button>
      <slick ref="main_slick" :options="slickOptions" @afterChange="handleAfterSlideChange">
        <a
          v-for="slide in slides"
          :key="slide.id"
          target="_blank"
          rel="noopener noreferrer"
          :href="slide.url"
          @click="sendAnalytics(slide.title)"
          class="slide-image"
          :style="{ backgroundImage: `url('${slide.image_path}')` }"
        ></a>
      </slick>
      <button
        v-show="sliderArrowsNavVisible"
        @click.prevent="nextSlide()"
        class="sc-nav-right"
      >&rsaquo;</button>
    </div>
    <div class="hs-slider__bottom">
      <button
        v-show="categoriesNavVisible"
        @click.prevent="navTranslateLeft()"
        class="sc-nav-left"
      >&lsaquo;</button>
      <nav :style="navTranslateStyle" class="slider-categories-nav" id="news-slider-nav">
        <a
          v-for="(slide, index) in slides"
          :key="slide.id"
          :class="{ active: currentSlideIndex == index }"
          href="#"
          @click.prevent="changeCurrentSlide(index)"
        >{{ slide.title }}</a>
      </nav>
      <button
        v-show="categoriesNavVisible"
        @click.prevent="navTranslateRight()"
        class="sc-nav-right"
      >&rsaquo;</button>
    </div>
    <div class="hs-slider__bottom-dots">
      <nav>
        <a
          v-for="(slide, index) in slides"
          :key="slide.order + '-dot'"
          :class="{ active: currentSlideIndex == index }"
          href="#"
          @click.prevent="changeCurrentSlide(index)"
        ></a>
      </nav>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import slidesJson from "@/generated/slides.json";

export default {
  data() {
    return {
      slides: {},
      currentSlideIndex: 0,
      navTranslateValue: 0,
      sliderArrowsNavVisible: false,
      categoriesNavVisible: false,
      slickOptions: {
        arrows: false,
        speed: 600
      }
    };
  },
  computed: {
    navTranslateStyle: function() {
      return { transform: "translateX(" + this.navTranslateValue + "px)" };
    }
  },
  methods: {
    sendAnalytics: function(slideTitle) {
    //   ga("send", "event", "banner", "banner click", slideTitle);
    },
    nextSlide: function() {
      this.$refs.main_slick.next();
    },
    prevSlide: function() {
      this.$refs.main_slick.prev();
    },
    navTranslateLeft: function() {
      let newValue = this.navTranslateValue + 100;
      if (newValue > 0) {
        newValue = 0;
      }
      this.navTranslateValue = newValue;
    },
    navTranslateRight: function() {
      let navAnchors = document.querySelectorAll("#news-slider-nav a");
      let navContainerWidth = document.querySelector("#news-slider-nav")
        .offsetWidth;
      let navAnchorsWidth = 0;
      navAnchors.forEach((el, i) => {
        navAnchorsWidth += el.offsetWidth;
      });

      let newValue = this.navTranslateValue - 100;
      if (newValue < navContainerWidth - navAnchorsWidth) {
        newValue = navContainerWidth - navAnchorsWidth;
      }
      this.navTranslateValue = newValue;
    },
    shouldShowNavSlideButtons: function() {
      let navAnchors = document.querySelectorAll("#news-slider-nav a");
      let navContainerWidth = document.querySelector("#news-slider-nav")
        .offsetWidth;

      let navAnchorsWidth = 0;
      navAnchors.forEach((el, i) => {
        navAnchorsWidth += el.offsetWidth;
      });

      if (navAnchorsWidth > navContainerWidth) {
        this.categoriesNavVisible = true;
      } else {
        this.categoriesNavVisible = false;
      }
    },
    reInit() {
      this.$refs.main_slick.destroy();
      this.$nextTick(() => {
        if (this.$refs.main_slick !== undefined) {
          this.$refs.main_slick.create();
        }
      });
    },
    handleAfterSlideChange: function(event, slick, currentSlide) {
      this.currentSlideIndex = currentSlide;
    },
    changeCurrentSlide: function(slideNumber) {
      this.$refs.main_slick.goTo(slideNumber);
    }
  },
  mounted() {
    let cmp = this;
    this.slides = slidesJson;

    setTimeout(function () {
      cmp.shouldShowNavSlideButtons();
    }, 1);

    window.addEventListener("resize", function() {
      cmp.shouldShowNavSlideButtons();
    });
    cmp.reInit();
  },
  components: {
    Slick
  }
};
</script>

<style lang="scss">
@import "@/scss/_general.scss";

.hs-slider {
  background: #fff;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // margin: 0 20px;
  // display: flex;
  // flex-direction: column;
  // overflow: hidden;

  .hs-slider__top {
    background: #fff;
    height: 100%;
    position: relative;

    @media only screen and (max-width: 1200px) {
      min-height: 38vw;
    }

    // display: flex;
    // align-items: center;

    .slick-slider {
      height: 100%;

      @media only screen and (max-width: 576px) {
        height: calc(38vw - 2px); // fix
      }

      .slick-list {
        height: 100%;

        .slick-track {
          height: 100%;

          .slick-slide {
            height: 100%;

            & > div {
              height: 100%;
            }
          }
        }
      }
    }

    .sc-nav-left {
      padding: 0;
      position: absolute;
      left: 10px;
      top: calc(50% - 20px);
      height: 46px;
      width: 46px;
      border: 1px #c8c8c8 solid;
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.6);
      cursor: pointer;
      font-size: 30px;
      line-height: 30px;
      color: #c8c8c8;
      font-weight: 100;
      padding-bottom: 5px;
      z-index: 1;
    }

    .sc-nav-right {
      padding: 0;
      position: absolute;
      right: 10px;
      top: calc(50% - 20px);
      height: 46px;
      width: 46px;
      border: 1px #c8c8c8 solid;
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.6);
      cursor: pointer;
      font-size: 30px;
      line-height: 30px;
      color: #c8c8c8;
      font-weight: 100;
      padding-bottom: 5px;
      z-index: 1;
    }

    .sc-nav-right,
    .sc-nav-left {
      &:focus,
      &:active {
        outline: none;
      }
    }

    img {
      max-width: 100%;
    }

    .slide-image {
      height: calc(100% - 2px);
      width: 100%;
      display: block;
      background-position: 50% 50% !important;
      background-size: cover !important;
      background-repeat: no-repeat !important;
    }
  }

  .hs-slider__bottom {
    // border-bottom: 2px #dadfe4 solid;
    padding: 0px 20px 0;
    position: relative;
    background: #fff;

    @media only screen and (max-width: 991px) {
      display: none;
    }

    .sc-nav-left {
      position: absolute;
      left: 0px;
      bottom: 5%;
      height: 40px;
      width: 30px;
      border: 0px #c8c8c8 solid;
      border-radius: 2px;
      background: #fff;
      cursor: pointer;
      font-size: 30px;
      line-height: 30px;
      color: #c8c8c8;
      font-weight: 100;
      padding-bottom: 5px;
      z-index: 1;

      &:focus {
        outline: none;
      }
    }

    .sc-nav-right {
      position: absolute;
      right: 0px;
      bottom: 5%;
      height: 40px;
      width: 30px;
      border: 0px #c8c8c8 solid;
      border-radius: 2px;
      background: #fff;
      cursor: pointer;
      font-size: 30px;
      line-height: 30px;
      color: #c8c8c8;
      font-weight: 100;
      padding-bottom: 5px;
      z-index: 1;

      &:focus {
        outline: none;
      }
    }

    nav {
      display: flex;
      flex-direction: row;
      position: relative;

      -webkit-transition: all 0.1s ease-in-out;
      -moz-transition: all 0.1s ease-in-out;
      -o-transition: all 0.1s ease-in-out;
      transition: all 0.1s ease-in-out;
    }

    a {
      display: inline-block;
      color: $headingText;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.4px;
      text-decoration: none;
      font-weight: 600;
      padding: 9px 10px;
      white-space: nowrap;
      border-top: 2px transparent solid;

      -webkit-transform: translateY(-2px);
      -moz-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
      -o-transform: translateY(-2px);
      transform: translateY(-2px);

      &.active,
      &:hover {
        color: $orange1;
        border-top: 2px $orange1 solid;
      }
    }
  }

  .hs-slider__bottom-dots {
    padding: 0px 20px 0;
    position: relative;
    background: #fff;
    display: none;

    @media only screen and (max-width: 991px) {
      display: block;
    }

    nav {
      width: 100%;
      text-align: center;
      padding: 8px 0;

      a {
        display: inline-block;
        margin-right: 12px;
        font-size: 22px;
        text-decoration: none;
        width: 16px;
        height: 16px;
        border-radius: 99px;
        background: #ddd;

        &.active {
          background: #222; 
        }
      }
    }
  }
}
</style>
